import { createUnknownComponentVNode as _$cc, createElementVNode as _$ce, map as _$ma, className as _$cn } from 'intact-vue-next';
import { TransitionGroup, Transition } from 'intact-vue-next';
import { makeMessagesStyles } from './styles';
import { ConfigProvider } from '../config';
export default function ($props, $blocks, $__proto__) {
  var _$cn2;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var k = this.get('classNamePrefix') || this.config.k;
  return _$cc(ConfigProvider, {
    'value': {
      classNamePrefix: k
    },
    'children': _$ce(2, 'div', _$cc(TransitionGroup, {
      'children': _$ma(this.messages, function ($value, $key) {
        return $value;
      }, $this)
    }), 2, _$cn((_$cn2 = {}, _$cn2[k + "-messages"] = true, _$cn2[makeMessagesStyles(k)] = true, _$cn2)))
  });
}
;